import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=6e9a7276&scoped=true&"
import script from "./FormLayout.vue?vue&type=script&lang=js&"
export * from "./FormLayout.vue?vue&type=script&lang=js&"
import style0 from "./FormLayout.vue?vue&type=style&index=0&id=6e9a7276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9a7276",
  null
  
)

export default component.exports